export const textPositions = ["Center", "Left", "Right"];
